import React from 'react';
import { Tab, Nav } from 'react-bootstrap';
import Slider from 'react-slick';

// import j0 from '../../../assets/img/jw/biz/b0.jpg';	
// import j1 from '../../../assets/img/jw/j1.jpg';
// import j2 from '../../../assets/img/jw/j2.jpg';
import j3 from '../../../assets/img/jw/j3.jpg';
import j4 from '../../../assets/img/jw/j4.jpg';

import b0 from '../../../assets/img/jw/biz/b0.jpg';
import b1 from '../../../assets/img/jw/biz/b1.jpg';
import b2 from '../../../assets/img/jw/biz/b2.jpg';

import l0 from '../../../assets/img/jw/life/l0.jpg';
import l1 from '../../../assets/img/jw/life/l1.jpg';
import l2 from '../../../assets/img/jw/life/l2.jpg';
import l3 from '../../../assets/img/jw/life/l3.jpg';

const adventuretab = [
    { icon: 'fas fa-mountain', text: 'Machu Picchu' },
    { icon: 'fas fa-flag', text: 'Mount Everest' },
    { icon: 'fas fa-hiking', text: 'Grand Canyon' },
]

// const bizSlider = [
//     { img: j0 },
//     { img: j1 },
//     { img: j2 },
//     { img: j3 },
//     { img: j4 },
// ]

const bizSlider = [
    { img: b0 },
    { img: b1 },
    { img: b2 },
]

const lifeSlider = [
    { img: l0 },
    { img: l1 },
    { img: l2 },
    { img: l3 },
]

// const adventureSlider = [
//     { img: a0 },
//     { img: a1 },
//     { img: a2 },
//     { img: a3 },
//     { img: a4 },
// ]

// const charitySlider = [
//     { img: c0 },
//     { img: c1 },
//     { img: c2 },
//     { img: c3 },
//     { img: c4 },
// ]


// const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     arrows: false,
//     fade: true,
//     cssEase: 'linear'
// }

// const settings2 = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     arrows: false,
//     fade: true,
//     cssEase: 'linear'
// }

// const settings3 = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     arrows: false,
//     fade: true,
//     cssEase: 'linear'
// }

// const settings4 = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1
// }
// function SampleNextArrow(props) {
//     const { onClick } = props
//     return (
//         <button className="slick-arrow next-arrow" onClick={onClick}><i className="fal fa-long-arrow-right" /></button>
//     )
// }

// function SamplePrevArrow(props) {
//     const { onClick } = props
//     return (
//         <button className="slick-arrow prev-arrow" onClick={onClick}><i className="fal fa-long-arrow-left" /></button>
//     )
// }


function Advancedtab(props) {

    // const [clicks, setClicks] = useState(1)

    // const oncrementItem = () => {
    //     setClicks(prev => prev + 1)
    // }

    // const decreaseItem = () => {
    //     if (clicks < 1) {
    //         setClicks(0)
    //     } else {
    //         setClicks(prev => prev - 1)
    //     }
    // }

    // const handleChange = (event) => {
    //     setClicks(event.target.value)
    // }

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        // nextArrow: <SampleNextArrow />,
        // prevArrow: <SamplePrevArrow />,
        dots: true,
        dotsClass: "product-gallery-arrow slick-dots slick-thumb",
        // customPaging: function (i) {
        //     return (
        //         <img src={`assets/img/shop/details-thumb-0${i + 1}.jpg`} alt="" />
        //     )
        // },
    }


    return (
        <section className="advanced-tab section-gap">
            <div className="container">
                {/* Tabs Buttons */}
                <div className="tab-buttons">
                    <Tab.Container defaultActiveKey="mission">
                        <Nav variant="tabs">
                            <Nav.Item>
                                <Nav.Link eventKey="mission">Professional History</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="history">Personal Life</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="businessgoals">Adventure</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="teammember">Impact</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content>
                            <Tab.Pane eventKey="mission">
                                <div className="tab-text-block left-image with-left-circle">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-lg-6 col-md-10">
                                            {/* <div className="block-image">
                                                <img src={j1} alt="" />
                                            </div> */}

                                            <div className="product-gallery clearfix">
                                                <div className="product-gallery-arrow" />
                                                <div className="gallery-slider-warp">
                                                    <Slider className="product-gallery-slider" {...settings}>
                                                        {bizSlider.map((item, i) => (
                                                            <div key={i} className="single-gallery-itam">
                                                                <img src={item.img} alt="" />
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-10">
                                            <div className="block-text">
                                                <h2 className="title">Who is J.W. Oliver Jr in business?</h2>
                                                <p>
                                                    J.W. Oliver is the Managing Partner of SupportDDS and ZimWorX.com

                                                    His objective is to assist organizations to leverage growth, increase productivity,
                                                    manage costs and free up time utilizing virtual/remote teams.
                                                    Proud to be a Christian based business(Win Win Win philosophy)
                                                    with a desire to help businesses be their very best while making
                                                    a Global Impact through professional work opportunities.
                                                </p>
                                                <br />
                                                <p>
                                                    As an entrepreneur since age 12 selling “PopRocks” from his middle school locker,
                                                    JW has started up more than 20+ companies from dental imaging, an insourcing center
                                                    in Africa, an international property management group, collegiate summer baseball
                                                    team, and even a skateboard park.
                                                </p>
                                                {/* <ul>
                                                    {missiontab.map((item, i) => (
                                                        <li key={i}>
                                                            <i className={item.icon} />
                                                            {item.text}
                                                        </li>
                                                    ))}
                                                </ul> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="history">
                                <div className="tab-text-block right-image with-right-circle">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-lg-6 col-md-10 order-2 order-lg-1">
                                            <div className="block-text">
                                                <h2 className="title">His personal life...</h2>
                                                <p>
                                                    J.W. Oliver was born in France the son of a proud, hard-working
                                                    Air Force Master Sergeant from North Carolina, and a Texan momma
                                                    who raised four kids and taught them to love Jesus. Spent most of
                                                    his life in Texas, where he and his wife married in 1994 and raised two children.
                                                </p>
                                                {/* <ul>
                                                    {historytab.map((item, i) => (
                                                        <li key={i}>
                                                            <i className={item.icon} />
                                                            {item.text}
                                                        </li>
                                                    ))}
                                                </ul> */}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-10 order-1 order-lg-2">
                                            {/* <div className="block-image">
                                                <img src={j2} alt="" />
                                            </div> */}

                                            <div className="product-gallery clearfix">
                                                <div className="product-gallery-arrow" />
                                                <div className="gallery-slider-warp">
                                                    <Slider className="product-gallery-slider" {...settings}>
                                                        {lifeSlider.map((item, i) => (
                                                            <div key={i} className="single-gallery-itam">
                                                                <img src={item.img} alt="" />
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="businessgoals">
                                <div className="tab-text-block left-image with-left-circle">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-lg-6 col-md-10">
                                            <div className="block-image">
                                                <img src={j3} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-10">
                                            <div className="block-text">
                                                <h2 className="title">What he does for fun</h2>
                                                <p>
                                                    J.W. is an avid traveler who enjoys seeing the world and sees an opportunity in every obstacle.

                                                    He has completed two ½ Iron-Men races, ten Half Marathons, hiked 6 days from Cusco to Machu Picchu
                                                    all after the age of 48. He is a pilot, ordained minister,
                                                    author, and hosts a podcast. He loves to see others laugh and smile,
                                                    and desires most of all to lift up and encourage others and show them Jesus.
                                                    <br />
                                                    He's been on numerous adventure trips, notably including:
                                                </p>
                                                <ul>
                                                    {adventuretab.map((item, i) => (
                                                        <li key={i}>
                                                            <i className={item.icon} />
                                                            {item.text}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>{/*  */}
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="teammember">
                                <div className="tab-text-block right-image with-right-circle">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-lg-6 col-md-10 order-2 order-lg-1">
                                            <div className="block-text">
                                                <h2 className="title">Impact</h2>
                                                <p>
                                                    {/* JW is proud to be a Christ focused entrepreneur, husband to an amazing wife,
                                                    and father to two awesome adult children who love the Lord.  */}
                                                    JW is proud to be a Christ focused entrepreneur, husband to an
                                                    amazing wife, and father to two awesome adult children who love the Lord.
                                                    JW started a non-profit that serves Haiti and Africa.
                                                    <br />

                                                    He has adopted a Win,
                                                    Win, Win philosophy of helping businesses be their very best through virtual
                                                    team members and making a Global Impact by creating professional work opportunities
                                                    and donating 51% of all profits to ministries around the world.

                                                    <br />
                                                    In 2011 after Haiti was hit with a large-scale earthquake.
                                                    Mr Denis Cady inspired me to visit Haiti after seeing the devastation
                                                    the earthquake had caused. Our goal was to find orphanages we could partner
                                                    with and support. Initially, we donated items like toys to children at the
                                                    orphanages but later realized that we could make a more meaningful impact
                                                    by sending children to school.  I had the privilege of meeting  some amazing
                                                    young men and women while on that trip to Haiti. We work directly with students
                                                    in Haiti, and visit on a regular basis helping to provide for the health and
                                                    welfare for these students. We do work with other schools and mission support
                                                    within the country.

                                                </p>
                                                {/* <ul>
                                                    {teammembertab.map((item, i) => (
                                                        <li key={i}>
                                                            <i className={item.icon} />
                                                            {item.text}
                                                        </li>
                                                    ))}
                                                </ul> */}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-10 order-1 order-lg-2">
                                            <div className="block-image">
                                                <img src={j4} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </div>
        </section>
    );
}
export default Advancedtab;